export const accuracyList = [
	{id: 1, acc: '-', acc_desc: ''},
	{id: 2, acc: 'n', acc_desc: '10-25%'},
	{id: 3, acc: 'nn', acc_desc: '25-50%'},
	{id: 4, acc: 'nnn', acc_desc: '+50%'}
];

export const sexList = [
	{id: 1, sex: '-'}, 
	{id: 2, sex: '♂'}, 
	{id: 3, sex: '♀'}
];

export const ageList = [
	{id: 1, age: '-'}, 
	{id: 2, age: '1kv'}, 
	{id: 3, age: '+1kv'}, 
	{id: 5, age: '2kv'},
	{id: 6, age: '+2kv'},
	{id: 7, age: '3kv'},
	{id: 8, age: '+3kv'},
];

export const plumageList = [
	{id: 1, plumage: '-'},
	{id: 2, plumage: 'ad'},
	{id: 3, plumage: 'juv'},
	{id: 4, plumage: 'n-puk'},
	{id: 5, plumage: 'pull'},
	{id: 6, plumage: 'jp'},
	{id: 7, plumage: 'vp'},
	{id: 8, plumage: 'tp'}
];

export const stateList = [
	{id: 1, state: '-'},
	{id: 2, state: 'p'},
	{id: 3, state: 'kiert'},
	{id: 4, state: 'm'},
	{id: 5, state: 'lask'},
	{id: 6, state: 'nous'},
	{id: 7, state: 'ä'},
	{id: 8, state: 'Ä'},
	{id: 9, state: 'än'},
	{id: 10, state: 'Än'},
	{id: 11, state: 'rumm'},
	{id: 13, state: 'N'},
	{id: 14, state: 'NNW'},
	{id: 15, state: 'NW'},
	{id: 16, state: 'WNW'},
	{id: 17, state: 'W'},
	{id: 18, state: 'WSW'},
	{id: 19, state: 'SW'},
	{id: 20, state: 'SSW'},
	{id: 21, state: 'S'},
	{id: 22, state: 'SSE'},
	{id: 23, state: 'SE'},
	{id: 24, state: 'ESE'},
	{id: 25, state: 'E'},
	{id: 26, state: 'ENE'},
	{id: 27, state: 'NE'},
	{id: 28, state: 'NNE'},
	{id: 29, state: 'N-E'},
	{id: 30, state: 'S-E'},
	{id: 31, state: 'S-W'},
	{id: 32, state: 'N-W'},
	{id: 33, state: 'var'},
	{id: 34, state: 'rev'},
	{id: 35, state: 'pysrev'},
	{id: 36, state: 'reng'},
	{id: 37, state: 'kontr'},
	{id: 38, state: 'pyyd'},
	{id: 39, state: 'yöm'},
	{id: 40, state: '?'},
	{id: 41, state: 'kuollut'},
];

export const brCodeList = [
	{id: 0,  name: 'add.undefined', cat: ''},
	{id: 10, name: '1',  cat: 'br_codes.improbable_nesting', desc: 'br_codes.br_ind_1_description',  short_desc: 'br_codes.br_ind_1_short_desc'},
	{id: 20, name: '2',  cat: 'br_codes.possible_nesting',   desc: 'br_codes.br_ind_2_description',  short_desc: 'br_codes.br_ind_2_short_desc'},
	{id: 30, name: '3',  cat: 'br_codes.possible_nesting',   desc: 'br_codes.br_ind_3_description',  short_desc: 'br_codes.br_ind_3_short_desc'},
	{id: 40, name: '4',  cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_4_description',  short_desc: 'br_codes.br_ind_4_short_desc'},
	{id: 50, name: '5',  cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_5_description',  short_desc: 'br_codes.br_ind_5_short_desc'},
	{id: 60, name: '6',  cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_6_description',  short_desc: 'br_codes.br_ind_6_short_desc'},
	{id: 61, name: '61', cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_61_description', short_desc: 'br_codes.br_ind_61_short_desc'},
	{id: 62, name: '62', cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_62_description', short_desc: 'br_codes.br_ind_62_short_desc'},
	{id: 63, name: '63', cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_63_description', short_desc: 'br_codes.br_ind_63_short_desc'},
	{id: 64, name: '64', cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_64_description', short_desc: 'br_codes.br_ind_64_short_desc'},
	{id: 65, name: '65', cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_65_description', short_desc: 'br_codes.br_ind_65_short_desc'},
	{id: 66, name: '66', cat: 'br_codes.probable_nesting',   desc: 'br_codes.br_ind_66_description', short_desc: 'br_codes.br_ind_66_short_desc'},
	{id: 70, name: '7',  cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_7_description',  short_desc: 'br_codes.br_ind_7_short_desc'},
	{id: 71, name: '71', cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_71_description', short_desc: 'br_codes.br_ind_71_short_desc'},
	{id: 72, name: '72', cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_72_description', short_desc: 'br_codes.br_ind_72_short_desc'},
	{id: 73, name: '73', cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_73_description', short_desc: 'br_codes.br_ind_73_short_desc'},
	{id: 74, name: '74', cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_74_description', short_desc: 'br_codes.br_ind_74_short_desc'},
	{id: 75, name: '75', cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_75_description', short_desc: 'br_codes.br_ind_75_short_desc'},
	{id: 80, name: '8',  cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_8_description',  short_desc: 'br_codes.br_ind_8_short_desc'},
	{id: 81, name: '81', cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_81_description', short_desc: 'br_codes.br_ind_81_short_desc'},
	{id: 82, name: '82', cat: 'br_codes.sure_nesting',       desc: 'br_codes.br_ind_82_description', short_desc: 'br_codes.br_ind_82_short_desc'},
];

export const uncertLevelList = [
	{id: 0,  name: 'add.undefined', desc: ''},
	{id: 10,  name: 'add.minor', desc: '1-10%'},
	{id: 20,  name: 'add.low', desc: '10-20%'},
	{id: 30,  name: 'add.medium', desc: '20-30%'},
	{id: 40,  name: 'add.high', desc: '30-40%'},
	{id: 50,  name: 'add.major', desc: '40-50%'},
];
